import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {
    AiOutlineAppstore,
    AiOutlineBook,
    AiOutlineBuild,
    AiOutlineCamera,
    AiOutlineCloudServer,
    AiOutlineCode,
    AiOutlineDashboard,
    AiOutlineDeploymentUnit,
    AiOutlineGroup,
    AiOutlineHome,
    AiOutlineLogin,
    AiOutlineThunderbolt,
    AiOutlineTool,
    AiOutlineWallet
} from 'react-icons/ai'
import {rbacActions} from "../../../config/rbac/actions";

export const getMenuItems = () => {

    return [
        {
            id: 'dashboard',
            link: '/dashboard',
            label: 'Dashboard',
            icon: <AiOutlineHome/>,
            rbac: rbacActions.ViewDashboard,
        }, {
            id: 'accounts',
            link: '/accounts',
            label: 'Accounts',
            icon: <AiOutlineWallet/>,
            rbac: rbacActions.ListAccounts,
        }, {
            id: 'users-group',
            link: '/users',
            label: 'Directory',
            icon: <AiOutlineGroup/>,
            rbac: 'ListUsers',
            defaultOpened: false,
            links: [{
                id: 'users',
                link: '/users',
                label: 'Users',
                icon: <AiOutlineLogin/>,
                rbac: rbacActions.ListUsers,
            }]
        }, {
            id: 'organizations',
            link: '/organizations',
            label: 'Organizations',
            icon: <AiOutlineCloudServer/>,
            rbac: rbacActions.ListOrganizations,
        }, {
            id: 'applications',
            link: '/applications',
            label: 'Applications',
            icon: <AiOutlineAppstore/>,
            rbac: rbacActions.ListApplications,
        }, {
            id: 'playbooks',
            link: '/playbooks',
            label: 'Playbooks',
            icon: <AiOutlineBook/>,
            rbac: rbacActions.ListPlaybooks,
        }, {
            id: 'executions',
            link: '/executions',
            label: 'Executions',
            icon: <AiOutlineThunderbolt/>,
            rbac: rbacActions.ListExecutions,
        }, {
            id: 'pipelines-group',
            link: '/pipelines',
            label: 'DevOps',
            icon: <AiOutlineBuild/>,
            rbac: rbacActions.ListPipelines,
            defaultOpened: false,
            links: [{
                id: 'pipelines',
                link: '/pipelines',
                label: 'Pipelines',
                icon: <AiOutlineBuild/>,
                rbac: rbacActions.ListPipelines,
            }, {
                id: 'pipeline-templates',
                link: '/pipeline-templates',
                label: 'Templates',
                icon: <AiOutlineAppstore/>,
                rbac: rbacActions.ListPipelineTemplates,
            }, {
                id: 'code-pipelines',
                link: '/code-pipelines',
                label: 'Code Pipelines',
                icon: <AiOutlineDeploymentUnit/>,
                rbac: rbacActions.ListCodePipelines,
            }, {
                id: 'code-repositories',
                link: '/code-repositories',
                label: 'Repositories',
                icon: <AiOutlineCode/>,
                rbac: rbacActions.ListCodeRepositories,
            }, {
                id: 'deployment-account-groups',
                link: '/deployment-account-groups',
                label: 'Account Groups',
                icon: <AiOutlineGroup/>,
                rbac: rbacActions.ListDeploymentAccountGroups,
            }]
        }, {
            id: 'application-screenshots-group',
            link: '/application-screenshots',
            label: 'Tools',
            icon: <AiOutlineTool/>,
            rbac: rbacActions.ListApplicationScreenshots,
            defaultOpened: false,
            links: [{
                id: 'application-screenshots',
                link: '/application-screenshots',
                label: 'Screenshots',
                icon: <AiOutlineCamera/>,
                rbac: rbacActions.ListApplicationScreenshots,
            }]
        }, {
            id: 'analytics',
            link: '/analytics',
            label: 'Analytics',
            icon: <AiOutlineDashboard/>,
            rbac: rbacActions.ListUsers,
        }] as PlatformNavbarMenuItem[];

};
